import { Page } from '@/core/architecture'

import { ConsoleEventCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleEventCreate Page
 * Implemented as a practical sample.
 */
export const ConsoleEventCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleEventCreateTemplate state={state} {...actions} />
}
